import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import { useNavigate } from "react-router";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import dateFormat, { masks } from "dateformat";
import { api_path } from "../shared";
export function QueueDetailComponent(props) {
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };
  const [getSubjectStatus, setSubjectStatus] = useState("Status details");
  const [showContent, setShowContent] = useState(true);
  const [searchParams] = useSearchParams();
  const id = searchParams.get("param");
  const [getUserRole, setUserRole] = useState(props.USER_ROLE);
  const [getUserID, setUserID] = useState(props.USER_ID);
  const [getBookingId, setBookingId] = useState();
  const [getQDate, setQDate] = useState();
  const [showTEU, setShowTEU] = useState(false);
  const [teuData, setTeuData] = useState([]);
  useEffect(() => {
    //console.log("id..."+id)
    //run when id Change value.
    if (id > 0) {
        setBookingId(id);
        setShowTEU(true);
        fetchTeuData()
    } else {
   
    }
  }, [id]);
  const showTeuData = true;
  const fetchTeuData = async () => {
    const response = await fetch(
      api_path + "/GET_BOOKINGS_ALL_Q.php?BOOKING_ID=" + id
    );
    const data = await response.json();
    setTeuData(data);
  };

  function DisplayTeuItem(props) {
    if (props.teuData.length > 0) {
      return (
        <table className="table">
        <thead>
        
  <tr>
      <th>Name</th>
            <th>Date</th>
          </tr>
            
            </thead>
            {showTeuData ? (
              <>
                {teuData.map((fdata,x) => {
                  return (
                <tbody>
                <tr key={fdata.QUEUE_ID}>
                <td>{x+1}. {fdata.USER_FIRSTNAME} ({fdata.USER_NICKNAME})</td>
                <td>{dateFormat(fdata.QUEUE_DTM, "dd-mmm-yyyy h:MM:ss TT")}</td>
                </tr>
              
                </tbody>
                 
                  );
                })}
              </>
            ) : (
              <p>You cannot see the data</p>
            )}
          </table>
      );
    } else {
    }
  }
  const closeTab = () => {
    window.opener = null;
    window.open("", "_self");
    window.close();
  };
  return (
    <Container maxWidth="lg">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          &nbsp;
        </Grid>
      </Grid>
      <Grid container spacing={2}></Grid>
      
        <Grid container spacing={2} className="BorderBox">
        <Grid item xs={12} sm={12}   style={{ display: "flex" }}
          justify-content="flex-end">
            <button onClick={closeTab} className="btn clear">X</button>
            </Grid>
        <Grid item xs={12} sm={12}>
              <label className="head2">Booking ID: {getBookingId} | Queue List</label>
            </Grid>
            {showTEU && (
                <Grid item xs={12} sm={12}>
           
                <DisplayTeuItem teuData={teuData} />
               
              </Grid>
                )}
                <Grid item xs={12} sm={12}   style={{ display: "flex" }}
          justify-content="flex-end">
                <Button
            type="button"
            variant="contained"
            className="btn-clear"
            onClick={closeTab}
          >
          Close
          </Button>
            
            </Grid>
        </Grid>
     
    </Container>
  );
}
